import { render, staticRenderFns } from "./OnDemandActivity.vue?vue&type=template&id=78dc1eda&scoped=true"
import script from "./OnDemandActivity.vue?vue&type=script&lang=js"
export * from "./OnDemandActivity.vue?vue&type=script&lang=js"
import style0 from "./OnDemandActivity.vue?vue&type=style&index=0&id=78dc1eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc1eda",
  null
  
)

export default component.exports